<template>
    <div class="loading-box" v-show="isloading">
        <div class="box">
            <!-- <span></span>
            <span></span>
            <span></span>
            <span></span>
            <span></span> -->
            <div class="loader-13"></div>
        </div>
    </div>
    
</template>

<script>
export default {
  props: {
    isloading: {
      type: Boolean,
      default: false
    }
  }
};
</script>
<style lang="scss">
.loading-box {
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  height: 100%;
  z-index: 3;
  @extend .bg;
  @extend .flex-cen;
  .loading {
    
    height: 15px;
    span {
      display: inline-block;
      width: 15px;
      height: 100%;
      margin-right: 5px;
      border-radius: 50%;
      background: #fffff0;
      animation: load 1.04s ease infinite;
      &:last-child{
          margin-right: 0px;
      }

    }
  }
}

.loading span:nth-child(1){
    animation-delay:0.13s;
}
.loading span:nth-child(2){
    animation-delay:0.26s;
}
.loading span:nth-child(3){
    animation-delay:0.39s;
}
.loading span:nth-child(4){
    animation-delay:0.52s;
}
.loading span:nth-child(5){
    animation-delay:0.65s;
}

 @keyframes load{
    0%{
        opacity: 1;
    }
    100%{
        opacity: 0;
    }
}
.box {
   
    color: rgba(255, 255, 255, 0.8);
    font-size: .4rem;
  
}
.loader-13:before,
.loader-13:after,
.loader-13 {
    border-radius: 50%;
    animation-fill-mode: both;
    animation: loader-13 1.8s infinite ease-in-out;
    width: 1em;
    height: 1em;
}
.loader-13 {
    
    position: relative;
   
    animation-delay: -0.16s;
    
}
.loader-13:before {
    right: 100%;
    
    animation-delay: -0.32s;
}
.loader-13:after {
    left: 100%;
}
.loader-13:before,
.loader-13:after {
    content: '';
    display: block;
    position: absolute;
    top: 0;
}

@keyframes loader-13 {
    0%, 80%, 100% {
        box-shadow: 0 1em 0 -1em;
    }
    40% {
        box-shadow: 0 1em 0 -.2em;
    }
}
</style>
